import { type FC, useEffect } from "react";
import { type ShopWorkCassetteProps } from "@userFrontend/features/publication/types/Cassettes";
import { useInView } from "react-intersection-observer";
import { pushDataLayer } from "@root/shared/utils/pushDataLayer";
import { type ModalLinkParams } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/type";
import { Presentation } from "./Presentation";

type Props = {
  gaLabel: string;
  linkGaAction?: string;
  scoutGaAction: string;
  entryGaAction: string;
  handleClickLink: (params: ModalLinkParams) => void;
} & ShopWorkCassetteProps;

export const ShopWorkCassette: FC<Props> = (props) => {
  const { ref, inView } = useInView();
  const { linkGaAction, scoutGaAction, entryGaAction, gaLabel } = props;
  useEffect(() => {
    if (inView) {
      pushDataLayer({
        event: `${linkGaAction}_show`,
        job_id: gaLabel,
      });
    }
  }, [gaLabel, inView, linkGaAction]);
  return (
    <Presentation
      {...props}
      linkGaAction={linkGaAction}
      scoutGaAction={scoutGaAction}
      entryGaAction={entryGaAction}
      gaLabel={gaLabel}
      cassetteRef={ref}
    />
  );
};
